import React from "react";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import LoginLogo from "./LoginLogo";

const messages = defineMessages( {
	header: {
		id: "login.defaultAside.header",
		defaultMessage: "Welcome back!",
	},
	message: {
		id: "login.defaultAside.message",
		defaultMessage: "Log in with your email address and password. If you don't remember your password, just reset it!",
	},
} );


/**
 * Display's the left side with the Login branding.
 *
 * @returns {ReactElement} The component that contains the message.
 */
function DefaultLoginAside() {
	return (
		<>
			<LoginLogo />
			<h1 className="screen-reader-text">
				<FormattedMessage { ...messages.header } />
			</h1>
			<p>
				<FormattedMessage { ...messages.message } />
			</p>
		</>
	);
}


export default injectIntl( DefaultLoginAside );
